export const app_loading_timeout_message = `Loading the application is taking longer than expected.
                                            Consider reloading the page.`;

export const user_view_loading_missing_therapist = `Loading this User View is taking longer than
                                                    expected. Consider reloading the page.`;

export const server_health_check_fail = `The server is not responding. Try reloading the page,
                                         if the problem persists contact your administrator`;
